import React from 'react'
import Link from 'gatsby-link'

import '../styles/main-navigation.scss'

export default () => (
    <div>
        <ul className="main-navigation">
            <li>
                <Link to="/">Page One</Link>
            </li>
            <li>
                <Link to="/page-2/">Page Two</Link>
            </li>
            <li>
                <Link to="/page-3/">Page Three</Link>
            </li>
        </ul>
    </div>
)



// WEBPACK FOOTER //
// ./src/components/navigation.jsx